export const RECOMMENDATIONS_ALLOWED_USER_IDS = [];
